import { Alert, Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useListSearchFilter } from '../context/useListSearchFilter';
import { useEikenMaterialList } from '../hooks/useEikenMaterialList';
import { EikenMaterialItem } from './EikenMaterialItem';

function HeaderItem({ width, children }: { children: ReactNode; width: string }) {
  return (
    <Typography
      width={width}
      sx={{ fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary' }}
    >
      {children}
    </Typography>
  );
}

export function EikenMaterialList() {
  const { items, hasError, error, refetch } = useEikenMaterialList();
  const { searchFilter } = useListSearchFilter();

  if (hasError) return <Alert severity="error">{error}</Alert>;

  const filteredList = items.filter((item) =>
    Object.values(item.content).some((question) =>
      question.toLowerCase().includes(searchFilter.toLowerCase())
    )
  );

  return (
    <Stack spacing={3}>
      <Box display="flex" alignItems="center" gap={2} paddingLeft={2} paddingRight={11}>
        <HeaderItems />
      </Box>
      <Stack spacing={3}>
        {filteredList.map((item) => (
          <EikenMaterialItem key={item.id} item={item} onDeleteSuccess={refetch} />
        ))}
        {filteredList.length === 0 && (
          <Box className="flex justify-center items-center ">
            <Typography variant="h6">No test found</Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  );
}

const HeaderItems = () => {
  return (
    <>
      <HeaderItem width="25%">Question</HeaderItem>
      <HeaderItem width="15%">Image</HeaderItem>
      <HeaderItem width="15%">Date Added</HeaderItem>
      <HeaderItem width="20%">Created By</HeaderItem>
      <HeaderItem width="15%">Organization</HeaderItem>
      <HeaderItem width="10%">Published</HeaderItem>
    </>
  );
};
